// extracted by mini-css-extract-plugin
module.exports = {"viewMore":"ForumResultItem_viewMore__CgBLL","avatarContainer":"ForumResultItem_avatarContainer__vU_si","arrow":"ForumResultItem_arrow__foCNh"};